import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export const Bonuses = () => {
  const bonuses = [{
    title: 'Plantillas Aesthetic para Instagram',
    desc: 'Diseños listos para usar.',
    value: '$15.000'
  }, {
    title: 'Guía: Tus primeras 10 clientas',
    desc: 'Plan paso a paso para arrancar.',
    value: '$12.000'
  }, {
    title: 'Lista secreta de proveedores premium',
    desc: 'Acceso a precios mayoristas.',
    value: '$20.000'
  }, {
    title: 'Entrenamiento mental de dueña de negocio',
    desc: 'Mentalidad que sostiene los resultados.',
    value: '$25.000'
  }, {
    title: 'Recetario: Las 5 velas más fáciles de vender',
    desc: 'Combinaciones probadas.',
    value: '$10.000'
  }];
  const total = '$82.000';
  return <section className="py-24 bg-text-dark text-cream relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-soft via-transparent to-transparent" data-id="element-16" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-17">
        <FadeIn className="text-center mb-16" data-id="element-18">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-soft/20 text-gold-light text-sm font-medium mb-6 border border-gold-soft/30" data-id="element-19">
            <Gift className="w-4 h-4" data-id="element-20" />
            <span data-id="element-21">Regalos exclusivos por inscripción</span>
          </div>
          <h2 className="text-4xl md:text-5xl mb-4 text-white leading-tight" data-id="element-22">
            5 Bonos.
            <br data-id="element-23" />
            <span className="text-gold-soft italic" data-id="element-24">Hoy gratis.</span>
          </h2>
          <p className="text-lg text-cream/70" data-id="element-25">
            Sumá más de <strong className="text-gold-light" data-id="element-26">{total}</strong> en
            herramientas extras.
          </p>
        </FadeIn>

        <div className="space-y-4 mb-10" data-id="element-27">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.08} direction="up" data-id="element-28">
              <div className="flex items-center justify-between p-5 md:p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors gap-4" data-id="element-29">
                <div className="flex items-center gap-4 min-w-0" data-id="element-30">
                  <div className="w-10 h-10 rounded-full bg-gold-soft/20 flex items-center justify-center shrink-0" data-id="element-31">
                    <Gift className="w-5 h-5 text-gold-light" data-id="element-32" />
                  </div>
                  <div className="min-w-0" data-id="element-33">
                    <h3 className="text-base md:text-lg font-bold text-white truncate" data-id="element-34">
                      {bonus.title}
                    </h3>
                    <p className="text-sm text-cream/60 hidden md:block" data-id="element-35">
                      {bonus.desc}
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-36">
                  <span className="block text-xs text-cream/40 line-through" data-id="element-37">
                    {bonus.value}
                  </span>
                  <span className="block text-gold-soft font-bold text-sm" data-id="element-38">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-39">
          <div className="bg-gold-soft/10 border border-gold-soft/40 rounded-2xl p-6 text-center backdrop-blur-sm" data-id="element-40">
            <p className="text-sm uppercase tracking-widest text-gold-light/80 mb-2" data-id="element-41">
              Valor total de los bonos
            </p>
            <p className="text-4xl md:text-5xl font-serif font-bold text-gold-light" data-id="element-42">
              <span className="line-through opacity-60 text-2xl mr-3" data-id="element-43">
                {total}
              </span>
              <span data-id="element-44">$0</span>
            </p>
            <p className="text-sm text-cream/70 mt-2" data-id="element-45">
              Incluidos sin costo extra al inscribirte hoy.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};